import { render, staticRenderFns } from "./TaskUpgradeFields.vue?vue&type=template&id=6bfaad5d&"
import script from "./TaskUpgradeFields.vue?vue&type=script&lang=js&"
export * from "./TaskUpgradeFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports